/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />

/* tslint:disable:no-unused-variable member-ordering */

namespace API.Client {
    'use strict';

    export class SellTypesApi {
        protected basePath = '/proxy/oag/gtw_rh';
        public defaultHeaders : any = {};

        static $inject: string[] = ['$http', '$httpParamSerializer'];

        constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
            if (basePath) {
                this.basePath = basePath;
            }
        }

        private extendObj<T1,T2>(objA: T1, objB: T2) {
            for(let key in objB){
                if(objB.hasOwnProperty(key)){
                    objA[key] = objB[key];
                }
            }
            return <T1&T2>objA;
        }

        /**
         * 
         * Get list of sell type.\n
         * @param branchCode 
         */
        public sellTypesBranchCodeGet (branchCode: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<SellTypesRS> {
            const localVarPath = this.basePath + '/sellTypes/{branchCode}'
                .replace('{' + 'branchCode' + '}', String(branchCode));

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'branchCode' is set
            if (!branchCode) {
                throw new Error('Missing required parameter branchCode when calling sellTypesBranchCodeGet');
            }
            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                                                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
    }
}
